/**
 * @documental
 * @export Option
 * @name
 * CheckboxGroup.Option
 */

import { FC, ReactNode } from "react";

/**
 * The `Option` component properties.
 */
export interface OptionProps {
  /**
   * The option value.
   */
  readonly value: string | number;

  /**
   * Indicates whether the checkbox is disabled.
   */
  readonly disabled?: boolean;

  /**
   * The option children.
   */
  readonly children?: ReactNode;
}

/**
 * A single option for the `CheckboxGroup` component.
 */
export const Option: FC<OptionProps> = () => {
  return null;
};
